"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body className="bg-canvas text-primary antialiased">
        <div className="flex min-h-screen items-center justify-center px-6">
          <div className="text-center space-y-6 max-w-md">
            <div className="text-7xl font-black bg-gradient-to-r from-red-400 to-orange-500 bg-clip-text text-transparent">
              500
            </div>
            <h1 className="text-2xl font-bold text-primary tracking-tight">
              Internal Server Error
            </h1>
            <p className="text-sm text-secondary leading-relaxed">
              Something went wrong on our end. Please try again.
            </p>
            <button
              onClick={() => reset()}
              className="inline-block rounded-control bg-brand-primary hover:bg-brand-primary-hover px-6 py-3 text-xs font-bold uppercase tracking-wider text-inverse transition-all duration-fast ease-standard shadow-sm hover:shadow-md"
            >
              Try Again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
